function ShopComingSoon() {
  return (
    <section className="section shop" id="shop">
      <div className="shop-box">
        <span>Online shop</span>
        <h2>Online checkout coming soon.</h2>
        <p>
          Soon you’ll be able to buy directly from the website. For now, orders
          and custom requests are available through Instagram, email, or phone.
        </p>

        <button disabled>Coming soon</button>
      </div>
    </section>
  );
}

export default ShopComingSoon;